import { Message } from 'element-ui'
const copy = {
  bind(el, { value }) {
    el.$value = value
    ;(el.handler = () => {
      if (!el.$value) {
        // 值为空
        console.log('无复制内容')
        return
      }
      // 动态 创建textarea标签
      const textarea = document.createElement('textarea')
      // 为textarea设置readonly属性，防止唤起键盘
      textarea.readOnly = 'readonly'
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      // 将要copy的值赋给textarea
      textarea.value = el.$value
      // 将textarea插入到body中
      document.body.appendChild(textarea)
      // 选中值 ，并复制
      textarea.select()
      const result = document.execCommand('Copy')
      if (result) {
        Message.success('复制成功')
      }
      document.body.removeChild(textarea)
    }),
      el.addEventListener('click', el.handler)
  },
  // 当传进来的值更新时触发
  componentUpdated(el, { value }) {
    el.$value = value
  },
  // 指令与元素解绑时，移除事件绑定
  unbind(el) {
    el.removeEventListener('click', el.handler)
  }
}

export default copy
